<template>
  <div class="quick-search">
    <userAutoComplete :place="t.search_user" v-on:selected="selectTo" />
  </div>
</template>

<script>
    import userAutoComplete from '@/components/autocomplete/userAutoComplete'

    export default {
        name: 'quickActions',
        components: {userAutoComplete},
        data () {
            return {
                t: this.$root.t
            }
        },
        methods: {
            setTo(id) {
                this.$router.push({ name: 'users', params: {id: id} });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .quick-search {
    height: 30vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/quickActions.vue